import CreatorSDK from '@creator/sdk';
import { getCreatorSdkConfig } from '@src/config';

const creatorSdk = new CreatorSDK(getCreatorSdkConfig());

export default creatorSdk;
